<template>
    <div class="price-change" :class="upDownColorClass">
        <span class="price-change__price" :class="priceColorClass">
            {{ formattedPrice }}
        </span>
        <span class="price-change__change" :class="priceColorClass">
            {{ formattedChange }}
        </span>
    </div>
</template>

<script >
import { computed } from 'vue-demi';
import { UP_DOWN_COLOR } from '../../common/enum';
const __sfc_main = {};
__sfc_main.props = {
  price: {
    type: Number,
    default: 0
  },
  change: {
    type: Number,
    default: 0
  },
  // 小数位数
  decimals: {
    type: Number,
    default: 3
  },
  // 涨跌色配置：0-红涨绿跌, 1-绿涨红跌
  upDownColor: {
    type: Number,
    default: UP_DOWN_COLOR.GREEN_UP
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;

  // 格式化价格
  const formattedPrice = computed(() => {
    return props.price.toFixed(props.decimals);
  });

  // 格式化涨跌幅
  const formattedChange = computed(() => {
    const sign = props.change >= 0 ? '+' : '';
    return `${sign}${props.change.toFixed(2)}%`;
  });

  // 涨跌色类名（控制颜色方案）
  const upDownColorClass = computed(() => {
    return props.upDownColor === UP_DOWN_COLOR.RED_UP ? 'price-change--red-up' : 'price-change--green-up';
  });

  // 价格颜色类名（控制上涨/下跌/持平状态）
  const priceColorClass = computed(() => {
    if (props.change > 0) return 'price-change__up';
    if (props.change < 0) return 'price-change__down';
    return 'price-change__neutral';
  });
  return {
    formattedPrice,
    formattedChange,
    upDownColorClass,
    priceColorClass
  };
};
export default __sfc_main;
</script>

<style lang="less" scoped>
.price-change {
    display: flex;
    gap: 0.04rem;
    font-size: 0.22rem;
    line-height: 0.3rem;
    letter-spacing: -0.02rem;

    // 持平 - 灰色（两种方案通用）
    &__neutral {
        color: #999;
    }

    // 绿涨红跌（默认）
    &--green-up {
        .price-change__up {
            color: #52c41a;
        }
        .price-change__down {
            color: #ff4d4f;
        }
    }

    // 红涨绿跌
    &--red-up {
        .price-change__up {
            color: #ff4d4f;
        }
        .price-change__down {
            color: #52c41a;
        }
    }
}
</style>
